export default __webpack_public_path__ + "static/media/project_fun_postgres.7579279a.png";